import { Link } from 'react-router-dom'

import { OPEN_SEARCH_EVENT } from './SearchModal'

interface Props {
  /** Open the off-canvas nav drawer. */
  onMenuClick: () => void
}

// Sticky bar shown only on narrow viewports (the sidebar is the desktop nav).
// It hosts the brand and the two controls a mobile reader actually needs:
// search and a menu toggle.
export default function MobileTopBar({ onMenuClick }: Props) {
  return (
    <header className="help-topbar">
      <Link to="/" className="help-topbar-brand">
        <span className="brand-dot" aria-hidden />
        <span>Chosen Help</span>
      </Link>
      <div className="help-topbar-actions">
        <button
          type="button"
          className="help-topbar-button"
          aria-label="Search the docs"
          onClick={() => window.dispatchEvent(new Event(OPEN_SEARCH_EVENT))}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden
          >
            <circle cx="9" cy="9" r="6" stroke="currentColor" strokeWidth="1.7" />
            <path
              d="M13.5 13.5L17 17"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
            />
          </svg>
        </button>
        <button
          type="button"
          className="help-topbar-button"
          aria-label="Open navigation menu"
          onClick={onMenuClick}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            aria-hidden
          >
            <path
              d="M3 6h14M3 10h14M3 14h14"
              stroke="currentColor"
              strokeWidth="1.7"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>
    </header>
  )
}
